import type { RootState } from 'types/root-state';
import { PageModelInitialState as initialState } from './initial-state';

const selectDomain = (state: RootState) => state.spl.pageModel || initialState;

export const selectPageModelData = (state: RootState) => selectDomain(state).data;

export const selectPageModelTitle = (state: RootState) =>
	selectPageModelData(state)?.properties.title || '';

export const selectPageModelSE0 = (state: RootState) => selectPageModelData(state).seoProperties;

export const selectPageModelNetwork = (state: RootState) => selectDomain(state).network;

export const selectPageModelRegionId = (state: RootState) =>
	selectPageModelData(state)?.properties?.regionId || null;

export const selectPageModelRegionDomain = (state: RootState) => {
	const regionId = selectPageModelRegionId(state);
	const { regions } = selectPageModelData(state);

	return regions.filter(region => region.regionId === regionId)[0].regionCode;
};

export const selectPageModelCategoryId = (state: RootState) =>
	selectDomain(state).data?.service?.categoryId || null;

export const selectPageModelCategoryText = (state: RootState) =>
	selectDomain(state).data?.service?.categoryText || null;

export const selectPageModelStoreId = (state: RootState) =>
	selectDomain(state).data?.store?.storeId || null;

export const selectPageModelStoreName = (state: RootState) =>
	selectDomain(state).data?.store?.storeName || null;

export const selectPageModelStoreOperationalTime = (state: RootState) =>
	selectDomain(state).data?.store?.operationalTime || null;

export const selectRulesText = (state: RootState) =>
	selectDomain(state).data?.rules?.rulesText || null;

export const selectPageModelRootBanner = (state: RootState) => {
	const banner = selectDomain(state).data?.rootBanner;

	if (banner && Object.keys(banner).length) return banner;
	return null;
};

export const selectModelInStoreStores = (state: RootState) => {
	const data = selectDomain(state).data?.instoreStores?.instoreServiceStores || [];
	return data.filter(({ available }) => available);
};
